import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  useTheme,
  useMediaQuery,
  Stack,
} from "@mui/material";

const MoveItemModal = ({ open, onClose, onSubmit, item, tables = [] }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm")); // small phones
  const isTablet = useMediaQuery("(min-width:600px) and (max-width:1200px)");
  const controlSize = isTablet ? "medium" : isXs ? "small" : "small";

  const [quantity, setQuantity] = useState(item?.quantity ?? 1);
  const [targetTable, setTargetTable] = useState(item?.target_table ?? "");

  useEffect(() => {
    // مزامنة عند تغيير الـ item الخارجي
    setQuantity(item?.quantity ?? 1);
    setTargetTable(item?.target_table ?? "");
  }, [item]);

  const handleSubmit = () => {
    if (!targetTable) return alert("يرجى اختيار طاولة مستهدفة");
    onSubmit({
      item_id: Number(item.id), // ✅ لازم رقم
      source_order_id: Number(item.order_id),
      quantity: Number(quantity),
      target_table: Number(targetTable),
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isXs}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: isXs ? "100vw" : isTablet ? "80vw" : 520,
          maxWidth: "96vw",
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle sx={{ fontSize: { xs: 18, sm: 20 }, px: { xs: 2, sm: 3 } }}>
        نقل الصنف: {item?.product_name}
      </DialogTitle>
      <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, py: 2 }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems="center"
        >
          <TextField
            label="الكمية"
            type="number"
            value={quantity}
            onChange={(e) =>
              setQuantity(Math.max(1, Number(e.target.value || 1)))
            }
            inputProps={{ min: 1, step: 1 }}
            size={controlSize}
            sx={{ width: { xs: "100%", sm: 140 } }}
            aria-label="كمية النقل"
          />

          <FormControl fullWidth sx={{ minWidth: { sm: 200 } }}>
            <InputLabel id="move-target-label">اختر الطاولة</InputLabel>
            <Select
              labelId="move-target-label"
              value={targetTable}
              label="اختر الطاولة"
              onChange={(e) => setTargetTable(e.target.value)}
              size={controlSize}
            >
              <MenuItem value="">
                <em>-- اختر الطاولة --</em>
              </MenuItem>
              {tables.map((table) => (
                <MenuItem key={table.id} value={table.id}>
                  {`طاولة ${table.name}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: { xs: 2, sm: 3 }, py: { xs: 1, sm: 1.25 } }}>
        <Button onClick={onClose} size={controlSize}>
          إلغاء
        </Button>
        <Button onClick={handleSubmit} variant="contained" size={controlSize}>
          نقل
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveItemModal;
